import { render, staticRenderFns } from "./ReadInvoice.vue?vue&type=template&id=cfbcb3d2&"
import script from "./ReadInvoice.vue?vue&type=script&lang=js&"
export * from "./ReadInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports